var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b54334ae-6c58-47a3-9cc2-7a8b75a6ca9d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .ba072f88-5bc8-41a2-ae76-91ffd7a43cd2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ba072f88-5bc8-41a2-ae76-91ffd7a43cd2",
    d: "M66.4,12.223h-6V11.207a1.839,1.839,0,0,0-3.677,0v1.016H43.284V11.207a1.839,1.839,0,0,0-3.677,0v1.016H33.6a6.811,6.811,0,0,0-6.8,6.8v24.8a6.811,6.811,0,0,0,6.8,6.8H66.4a6.811,6.811,0,0,0,6.8-6.8v-24.8A6.811,6.811,0,0,0,66.4,12.223Zm3.127,31.6A3.131,3.131,0,0,1,66.4,46.954H33.6a3.131,3.131,0,0,1-3.127-3.127v-24.8A3.131,3.131,0,0,1,33.6,15.9h6.005v1.21a1.839,1.839,0,0,0,3.677,0V15.9H56.716v1.21a1.839,1.839,0,0,0,3.677,0V15.9h6a3.131,3.131,0,0,1,3.127,3.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba072f88-5bc8-41a2-ae76-91ffd7a43cd2",
    d: "M59.671,25.228H39.66a1.839,1.839,0,1,0,0,3.677H59.671a1.839,1.839,0,1,0,0-3.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba072f88-5bc8-41a2-ae76-91ffd7a43cd2",
    d: "M59.671,34.022H39.66a1.839,1.839,0,1,0,0,3.677H59.671a1.839,1.839,0,1,0,0-3.677Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/Appointments.13a1dda37297a92859d021bfc5d4ded4.svg";
export { ForwardRef as ReactComponent };